export default "__VITE_ASSET__DXZy53oL__"